import React, { useRef, useEffect } from 'react';
import paper from 'paper';

const Gum = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    paper.setup(canvasRef.current);

    const colors = [
      'pink', 'pink', 'pink', 'pink', 'pink', 'pink',
      'pink', 'pink', 'pink', 'pink', 'pink', 'pink',
    ];

    const curves = [];
    for (let i = 0; i < colors.length; i++) {
      const curve = new paper.Path();
      curve.strokeColor = colors[i];
      curve.strokeWidth = 8;
      curve.strokeJoin = 'round';

      // Adjust the circular path parameters here
      const radius = 5 + i * 10;
      const segments = 100;

      for (let j = 0; j < segments; j++) {
        const angle = (j / segments) * (Math.PI * 2.1);
        const x = Math.cos(angle) * radius + paper.view.center.x;
        const y = Math.sin(angle) * radius + paper.view.center.y;
        curve.add(new paper.Point(x, y));
      }

      curves.push(curve);
    }

    const onMouseMove = (event) => {
      const mousePoint = event.point;
      for (let i = 0; i < curves.length; i++) {
        const curve = curves[i];
        for (let j = 0; j < curve.segments.length; j++) {
          const segment = curve.segments[j];
          const distance = segment.point.getDistance(mousePoint);
          const bendFactor = 20 / (distance + 1);
          const direction = segment.point.subtract(mousePoint).normalize();
          segment.point = segment.point.add(direction.multiply(bendFactor));
        }
      }
    };

    paper.view.on('mousemove', onMouseMove);

    return () => {
      paper.view.off('mousemove', onMouseMove);
      paper.project.clear();
    };
  }, []);

  return <canvas ref={canvasRef} style={{ width: '100%', height: '100%' }} />;
};

export default Gum;
